import { PlaylistValidations } from 'types/playlists.types';
import { fieldValidationMessages, formValidations } from 'app/constants';
import * as yup from 'yup';

export const getMaxTitleLength = (validations?: PlaylistValidations) =>
  validations?.properties.title.maxLength ||
  formValidations.MAX_SHORT_TEXT_LENGTH;

export const getTitleValidations = (maxTitleLength: number) => {
  return yup.object().shape({
    title: yup
      .string()
      .required('')
      .max(maxTitleLength, fieldValidationMessages.MAX_CHAR(maxTitleLength)),
  });
};
